import { useInfiniteQuery } from '@tanstack/react-query';
import { getFinancesGamesPlayers, queryKeys } from '@vgrubs/components';
import { GamesRange } from './gamesFormat';

const PAGE_SIZE = 20;

/**
 * The players of the range, biggest `revenue` first, a page at a time. The
 * route answers a bare array, so a page shorter than PAGE_SIZE is the end.
 * The card shows the start of the first page; the modal scrolls through the
 * rest from the same cache.
 */
export const useGamesPlayers = (range: GamesRange) => {
  const query = useInfiniteQuery({
    queryKey: queryKeys.admin.financesGames.players(range),
    initialPageParam: 1,
    queryFn: async ({ pageParam }) =>
      (
        await getFinancesGamesPlayers({
          ...range,
          page: pageParam,
          limit: PAGE_SIZE,
        })
      ).data.data ?? [],
    getNextPageParam: (last, pages) =>
      last.length === PAGE_SIZE ? pages.length + 1 : undefined,
  });

  return {
    players: query.data?.pages.flat() ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    hasNextPage: !!query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  };
};
